import moment from 'moment';
import { DAY_NAMES } from '../../../consts/initialValues';
import changeObjectKeysCamelToUnderscore from '../../../utils/changeObjectKeysCamelToUnderscore';
import { isArrayEmpty } from '../../../utils/isDefined';

const toTimeMs = time => {
  if (time == null) return null;
  const m = moment(time);
  return (m.hours() * 3600 + m.minutes() * 60) * 1000;
};

const mapScheduleForUpdate = ({ schedule }) => {
  const {
    duration,
    endDateSet,
    promptText,
    startDateSet,
    reccurence_0,
    reccurence_1,
    reccurence_2,
    reccurence_3,
    reccurence_4,
    reccurence_5,
    reccurence_6,
    ...restSchedule
  } = schedule;

  const days_of_week = [
    reccurence_0,
    reccurence_1,
    reccurence_2,
    reccurence_3,
    reccurence_4,
    reccurence_5,
    reccurence_6
  ].reduce((acc, el, i) => (el ? [...acc, DAY_NAMES[i]] : acc), []);

  const {
    disable_recording_prompts,
    end_date,
    end_time,
    forward_number,
    hangup,
    name,
    prompt,
    reccurence_end_date,
    reccurence_end_type,
    recurrence_type,
    start_date,
    start_time,
    type
  } = changeObjectKeysCamelToUnderscore(restSchedule);

  return {
    name,
    action: {
      disable_recording_prompts,
      forward_number,
      hangup,
      prompt,
      type
    },
    event_schedule: {
      interval: recurrence_type !== 'NONE' ? 1 : null,
      start: {
        date: start_date,
        time: toTimeMs(start_time)
      },
      end: {
        date: end_date,
        time: toTimeMs(end_time)
      },
      recurrence_type,
      days_of_week: recurrence_type === 'WEEKLY' ? days_of_week : null,
      end_date:
        reccurence_end_type === 'DATE'
          ? {
              type: 'Date',
              date: reccurence_end_date
            }
          : null,
      recurrence_range_type: 'NONE',
      ...(start_date != null && mapStartDate({ recurrence_type, start_date }))
    }
  };
};

export default mapScheduleForUpdate;

const mapStartDate = ({ recurrence_type, start_date }) => {
  switch (recurrence_type) {
    case 'MONTHLY_ABSOLUTE':
      return {
        day_of_month: moment(start_date).date(),
        month_of_year: null
      };
    case 'YEARLY_ABSOLUTE':
      return {
        day_of_month: moment(start_date).date(),
        month_of_year: moment(start_date).month() + 1
      };
    default:
      return { day_of_month: null, month_of_year: null };
  }
};
